// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-EEoHt";
var _4 = "closeIcon-1zOwb";
var _5 = "title-1njSl";
var _6 = "info-3zMSa";
var _7 = "title__icon-1bWC9";
var _8 = "description-vtj3S";
var _9 = "buttons-1m041";
var _a = "button_normal-IhRa0";
var _b = "button_accent-3WZIn";
var _c = "button_disabled-3qn_r";
var _d = "button_loader-23cfS";
var _e = "input_wrapper-2T-jS";
var _f = "resend_timer-244Mi";
var _10 = "resend_timer__link-3AnBn";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "closeIcon", _5 as "title", _6 as "info", _7 as "title__icon", _8 as "description", _9 as "buttons", _a as "button_normal", _b as "button_accent", _c as "button_disabled", _d as "button_loader", _e as "input_wrapper", _f as "resend_timer", _10 as "resend_timer__link" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "closeIcon": _4, "title": _5, "info": _6, "title__icon": _7, "description": _8, "buttons": _9, "button_normal": _a, "button_accent": _b, "button_disabled": _c, "button_loader": _d, "input_wrapper": _e, "resend_timer": _f, "resend_timer__link": _10 }
